module.exports = __webpack_public_path__ + "img/fig-9.04e08a8b.png";